export default "__VITE_ASSET__5f44ac3c__"